import { get, getViaAuth, responseValidator } from '../../apis/api';
import { API } from '../../apis';

export const getAllTransactions = async (
    setLoading: any,
    setData: any,
    page: number,
    pageSize: number,
    query: string,
    setCount: any,
) => {
    setLoading(true);
    await getAllTransactionsCount(setLoading, setCount, page, pageSize, query);
    await getViaAuth(`${API.transaction.getAll}/${page}/${pageSize}${query}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
        }
    });
};

export const getAllTransactionsCount = (
    setLoading: any,
    setData: any,
    page: number,
    pageSize: number,
    query: string,
) => {
    setLoading(true);
    getViaAuth(`${API.transaction.getCount}/${page}/${pageSize}${query}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) setData(response.value);
    });
};

export const getTransactionMarketTypes = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getTransactionMarketType).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'نوع ارز' }, ...response.data.value]);
        }
    });
};

export const getTransactionStates = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getTransactionStates).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه وضعیت ها' }, ...response.data.value]);
        }
    });
};

export const getTransactionSourceTypes = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getTransactionSourceTypes).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه مبدا ها' }, ...response.data.value]);
        }
    });
};

export const getDepositCurrencyType = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getDepositCurrencyType).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'نوع واریز' }, ...response.data.value]);
        }
    });
};

export const getTransactionTypes = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getTransactionTypes).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه تراکنش ها' }, ...response.data.value]);
        }
    });
};

export const getTransactionPlatforms = (setLoading: any, setData: any) => {
    setLoading(true);
    get(API.enum.getPlatforms).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData([{ id: -1, title: 'همه پلتفرم ها' }, ...response.data.value]);
        }
    });
};

export const getTransactionDetailById = async (
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setData: React.Dispatch<React.SetStateAction<any>>,
    setTimer: React.Dispatch<React.SetStateAction<any>>,
    Id: string,
) => {
    setLoading(true);
    await getViaAuth(API.transaction.getDetails + `/${Id}`).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
            setTimer(new Date(response.value.paymentDate).getTime() + 72 * 60 * 60 * 1000);
        } else if (response.status === 404) {
            setData(undefined);
        }
    });
};
